import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a5fdd518&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a5fdd518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fdd518",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomLink: require('/Users/daiyu/Desktop/work-code/bantervideo/components/CustomLink/index.vue').default,Notification: require('/Users/daiyu/Desktop/work-code/bantervideo/components/Notification/index.vue').default,Footer: require('/Users/daiyu/Desktop/work-code/bantervideo/components/Footer/index.vue').default})
